module.exports = __webpack_public_path__ + "img/quoted.1d639c6a.svg";